import * as React from "react";

export type CollabComposeCardProps = {
  children: React.ReactNode;
  className?: string;
};

/** Bordered compose shell matching WordPlugin compose card. */
export const CollabComposeCard: React.FC<CollabComposeCardProps> = ({ children, className }) => (
  <div className={`collab-compose-card${className ? ` ${className}` : ""}`}>{children}</div>
);

export default CollabComposeCard;
